import {
  ClipboardIcon,
  InformationCircleIcon,
  MegaphoneIcon,
  QuestionMarkCircleIcon,
  Square2StackIcon,
} from '@heroicons/react/24/outline';
import Dropdown, { Option } from 'components/commercetools-ui/atoms/dropdown';
import React, { useEffect, useState } from 'react';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { tablet, largeDesktop, desktop, mediumDesktop, semiLargeDesktop, extraLargeDesktop } from 'helpers/utils/screensizes';
import useWindowWidth from 'helpers/hooks/useBrowerWidth';
import useTouchDevice from 'helpers/hooks/useTouchDevice';

export const sidebarSections = [
  {
    name: 'Product overview',
    icon: <InformationCircleIcon className="w-28 text-[#666] 2xl:w-32" />,
    value: 'product-overview-scroll',
  },
  { name: 'Technical info', icon: <ClipboardIcon className="w-28 text-[#666] 2xl:w-32" />, value: 'specifier-info' },
  { name: 'Advice', icon: <MegaphoneIcon className="w-28 text-[#666] 2xl:w-32" />, value: 'advice-section' },
  {
    name: 'Related Products',
    icon: <Square2StackIcon className="w-28 text-[#666] 2xl:w-32" />,
    value: 'related-products',
  },
  //   { name: 'FAQs', icon: <QuestionMarkCircleIcon className="w-32 text-[#666]" />, value: 'faq-section' },
];


function SidebarPDP() {
  const [activeSection, setActiveSection] = useState(0);
  const [isTablet] = useMediaQuery(tablet);
  const [isLargeDesktop] = useMediaQuery(semiLargeDesktop);
  const [isHugeLargeDesktop] = useMediaQuery(extraLargeDesktop);
  const [isMediumDesktop] = useMediaQuery(mediumDesktop);
  const [isDesktop] = useMediaQuery(desktop);
  const { isTouchDevice } = useTouchDevice();
  const [distanceToTop, setDistanceToTop] = useState(1000);
  const [sidebarHeight, setSidebarHeight] = useState(0);
  const width = useWindowWidth();

  const scrollTo = (ele: HTMLElement) => {
    const position = ele.getBoundingClientRect();
    window.scrollTo({
      top: position.top + window.scrollY - (isHugeLargeDesktop? 115 : isLargeDesktop ? 90 : isMediumDesktop ? 50 : isTablet? 75: 100),
      behavior: 'smooth',
    });
  };
  const scrollToDesktop = (id: string) => {
    const ele = document.getElementById(id);
    if (ele) {
      scrollTo(ele);
    }
  };
  const scrollToMobile = (option: Option) => {
    const ele = document.getElementById(option.value.toString());
    if (ele) {
      scrollTo(ele);
    }
  };


  const handleClick = (index: React.SetStateAction<number>, id: string) => {
    scrollToDesktop(id);
  };

  useEffect(() => {
    const handleScroll = () => {
      const element1 = document.getElementById('product-overview');
      const element2 = document.getElementById('specifier-info-title');
      const element3 = document.getElementById('advice-section');
      const element4 = document.getElementById('related-products-title');
      //   const element5 = document.getElementById('faq-section');

      if (element1) {
        const rect = element1.getBoundingClientRect();
        const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight/2;

        if (isInView) {
          setActiveSection(0);
        }
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const distance = rect.top + scrollTop;
        setDistanceToTop(distance);
      }
      if (element2) {
        const rect = element2.getBoundingClientRect();
        // const isInView =
        //   rect.top >= 0 &&
        //   rect.bottom <=
        //     (isLargeDesktop
        //       ? window.innerHeight - 275
        //       : isMediumDesktop
        //       ? window.innerHeight
        //       : isTablet
        //       ? window.innerHeight - 500
        //       : window.innerHeight - 200);
        const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight /2 ;

        if (isInView) {
          setActiveSection(1);
        }
      }
      if (element3) {
        const rect = element3.getBoundingClientRect();
        const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight + 200;

        if (isInView) {
          setActiveSection(2);
        }
      }
      if (element4) {
        const rect = element4.getBoundingClientRect();
        // const isInView =
        //   rect.top >= 0 &&
        //   rect.bottom <=
        //     (isLargeDesktop
        //       ? window.innerHeight - 300
        //       : isMediumDesktop
        //       ? window.innerHeight
        //       : isTablet
        //       ? window.innerHeight - 650
        //       : window.innerHeight);
        const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight/2;

        if (isInView) {
          setActiveSection(3);
        }
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const distance = rect.top + scrollTop;
        setSidebarHeight(distance);
      }
      //   if (element5) {
      //     const rect = element5.getBoundingClientRect();
      //     const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

      //     if (isInView) {
      //       setActiveSection(4)
      //     }

      //   }
    };


    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMediumDesktop, isTablet, isDesktop]);

  return (
    <>
      {width !== null && width < 1024 ? (
        <div
        //   style={{ marginTop: `${distanceToTop / 20 - 30}rem` }} 
          className="absolute w-full left-full z-10 mb-48 w-screen -translate-x-full px-24 lg:grid lg:grid-cols-12"
        >
          <Dropdown
            selectOptions={sidebarSections}
            selectOnChange={scrollToMobile}
            selectDropdownClassNames="p-16 w-full"
          ></Dropdown>
        </div>
      ) : (
        <div
          style={{ height: `${sidebarHeight / 15 - 6}rem` }}
          className="relative mt-[5rem] "
        >
          <div className="h-full flex-col text-18 font-semibold leading-6 ">
            <div className="sticky left-0 top-[10rem] 2xl:top-[13rem] !z-[40] mb-40 w-fit">
              {sidebarSections.map((section, index) => (
                <div
                  className={`flex items-center gap-12 py-24 pl-18 hover:cursor-pointer 2xl:pl-32 ${
                    index === activeSection ? 'border-l-4 border-[#090909]' : 'border-l-4 border-[#F3EDE9]'
                  }`}
                  key={index}
                  onClick={() => handleClick(index, section.value)}
                >
                  {section.icon}
                  <span className="text-16 font-semibold leading-6 text-primary-black lg:text-14 3xl:text-18">
                    {section.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SidebarPDP;
